'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('loadImage', function ($q) {
    return function (src) {

      var deferred = $q.defer();

      var xhr = new XMLHttpRequest();

      xhr.open('GET', src, true);

      xhr.responseType = 'arraybuffer';

      xhr.onload = function () {
        if (this.status == 200) {
          var arr = new Uint8Array(this.response);

          var raw = '',
              i = void 0,
              j = void 0,
              subArray = void 0,
              chunk = 5000;
          for (i = 0, j = arr.length; i < j; i += chunk) {
            subArray = arr.subarray(i, i + chunk);
            raw += String.fromCharCode.apply(null, subArray);
          }

          deferred.resolve('data:image/jpeg;base64,' + btoa(raw));
        } else {
          deferred.reject({ message: this.statusText });
        }
      };

      xhr.send();

      return deferred.promise;
    };
  });
};

require('angular');

/**
 * 加载远程图片
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/services/loadImage.js
// module id = 150
// module chunks = 0